import React, { useEffect, useState, useCallback } from "react";

/* data imports */
import { towerItemsData } from "./game-data/towerItemsData";

/* comp imports */
import TowerLeftArea from "./games-components/TowerLeftArea";
import TowerRightArea from "./games-components/TowerRightArea";

/* function imports */
import { shuffleArray } from "../utils/shuffleArray";
import TowerStoryWrapperStart from "./games-components/TowerStoryWrapperStart";

const TowerGame = ({ handleRedirect }) => {
  const [isGameStart, setIsGameStart] = useState(false);
  const [showStoryStart, setShowStoryStart] = useState(true);
  const [hoveredItem, setHoveredItem] = useState("");
  const [gameLevel, setGameLevel] = useState(1);
  const [levelItemsData, setLevelItemsData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemFlag, setSelectedItemFlag] = useState("");
  const [isGameOver, setIsGameOver] = useState(false);
  const [isGameComplete, setIsGameComplete] = useState(false);
  const [isLevelWin, setIsLevelWin] = useState(false);

  const reloadLevelItemData = useCallback(() => {
    if (gameLevel) {
      let tempData = towerItemsData.filter((item) => item.id === gameLevel);

      if (tempData.length > 0) {
        const randomized = shuffleArray(tempData[0].data);
        setLevelItemsData(randomized);
      }
    }
  }, [gameLevel]);

  useEffect(() => {
    reloadLevelItemData();
  }, [reloadLevelItemData]);

  const itemHoverHandler = (itemName) => {
    if (itemName !== "") {
      setHoveredItem(itemName);
    } else {
      setHoveredItem("");
    }
  };

  const itemSelectorHandler = (item) => {
    if (item) {
      const alreadyExists = selectedItems.some(
        (selected) => selected.id === item.id
      );

      if (!alreadyExists && selectedItems.length < 10) {
        setSelectedItemFlag(item.flag);
        setSelectedItems([...selectedItems, item]);
      }
    }
  };

  useEffect(() => {
    if (selectedItems.length === 10) {
      let timer;
      if (gameLevel < 3) {
        timer = setTimeout(() => {
          setIsLevelWin(true);
        }, 1000);
      } else if (gameLevel === 3) {
        timer = setTimeout(() => {
          setIsGameComplete(true);
        }, 1000);
      }
      return () => clearTimeout(timer);
    }
  }, [selectedItems.length, gameLevel]);

  const startNextLevel = () => {
    setSelectedItemFlag("");
    setSelectedItems([]);
    setGameLevel(gameLevel + 1);
    setIsLevelWin(false);
  };

  useEffect(() => {
    if (selectedItemFlag) {
      if (selectedItemFlag === "unhealthy") {
        setIsGameOver(true);
      }
    }
  }, [selectedItemFlag]);

  useEffect(() => {
    if (isGameOver) {
      setSelectedItemFlag("");
      setSelectedItems([]);
      setLevelItemsData([]);
      setHoveredItem("");
    }
  }, [isGameOver]);

  const restartGame = () => {
    setGameLevel(1);
    setIsGameOver(false);
    setSelectedItems([]);
    setIsLevelWin(false);
    setIsGameComplete(false);
    reloadLevelItemData();
  };

  const gameCompleteHandler = () => {
    handleRedirect("/games");
  };

  return (
    <div
      className={`tower-game-container ${isGameStart ? "game-started-bg" : ""}`}
    >
      <div className="tower-left-area">
        {isGameStart && (
          <TowerLeftArea
            itemHoverHandler={itemHoverHandler}
            hoveredItem={hoveredItem}
            levelItemsData={levelItemsData}
            itemSelectorHandler={itemSelectorHandler}
            selectedItems={selectedItems}
            selectedItemFlag={selectedItemFlag}
            gameLevel={gameLevel}
            isGameOver={isGameOver}
            restartGame={restartGame}
            startNextLevel={startNextLevel}
            isLevelWin={isLevelWin}
            isGameComplete={isGameComplete}
            gameCompleteHandler={gameCompleteHandler}
          />
        )}
      </div>
      <TowerRightArea />

      {showStoryStart && (
        <TowerStoryWrapperStart
          setShowStoryStart={setShowStoryStart}
          setIsGameStart={setIsGameStart}
        />
      )}
    </div>
  );
};

export default TowerGame;
